import React from 'react'
import type { BoxProps as MuiBoxProps } from '@material-ui/core/Box'
import MuiBox from '@material-ui/core/Box'

export type BoxProps = MuiBoxProps

function Box(props: BoxProps) {
  return <MuiBox {...props} />
}

export default Box
